module.exports = {
          srcSet: __webpack_public_path__ + "public/a3e5f284da4c845c5526d053b2fdff8c-40.png"+" 40w",
          images:[ {path: __webpack_public_path__ + "public/a3e5f284da4c845c5526d053b2fdff8c-40.png",width: 40,height: 40}],
          src: __webpack_public_path__ + "public/a3e5f284da4c845c5526d053b2fdff8c-40.png",
          toString:function(){return __webpack_public_path__ + "public/a3e5f284da4c845c5526d053b2fdff8c-40.png"},
          
          width: 40,
          height: 40
        }